import { render, staticRenderFns } from "./app-bottom.vue?vue&type=template&id=5b7dfb63&scoped=true&"
import script from "./app-bottom.vue?vue&type=script&lang=js&"
export * from "./app-bottom.vue?vue&type=script&lang=js&"
import style0 from "./app-bottom.vue?vue&type=style&index=0&id=5b7dfb63&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7dfb63",
  null
  
)

export default component.exports